export default "__VITE_ASSET__BxTD9suj__"